import Phaser from 'phaser';

/** 게임 화면 비율 — 모바일 세로 모드 (9:16) */
export const GAME_WIDTH = 390;
export const GAME_HEIGHT = 844;

/** 구름 관련 상수 */
export const CLOUD = {
  /** 구름 가로 크기 */
  WIDTH: 72,
  /** 구름 세로 크기 */
  HEIGHT: 24,
  /** 계단 간 세로 간격 */
  BASE_GAP: 50,
  /** 계단 간 가로 오프셋 */
  HORIZ_OFFSET: 50,
  /** 최소 간격 (난이도 상승 시) */
  MIN_GAP: 40,
  /** 화면에 보이는 구름 최대 개수 */
  VISIBLE_COUNT: 20,
};

/** 플레이어 상수 */
export const PLAYER = {
  SIZE: 28,
  JUMP_DURATION: 120, // ms (더 빠른 템포)
};

/** 게이지 상수 */
export const GAUGE = {
  /** 초기 제한 시간 (ms) */
  INITIAL_TIME: 2000,
  /** 최소 제한 시간 (ms) */
  MIN_TIME: 800,
  /** 스텝당 감소량 (ms) */
  DECAY_PER_STEP: 5,
  /** 무지개 구름으로 회복되는 시간 (ms) */
  RAINBOW_RECOVERY: 300,
};

/** 콤보 상수 */
export const COMBO = {
  AURORA_THRESHOLD: 50,
  FEVER_THRESHOLD: 100,
  FEVER_DURATION: 3000, // ms
  FEVER_SCORE_MULTIPLIER: 5,
};

/** 스테이지 높이 경계 */
export const STAGE = {
  DAY_END: 100,
  SUNSET_END: 250,
  NIGHT_END: 500,
  // 500+ = SPACE
};

/** 스테이지별 색상 팔레트 */
export const PALETTES = {
  DAY: {
    sky: [0x87CEEB, 0x6CB4EE, 0x4DA6E0],
    cloud: 0xFFFFFF,
    cloudAlt: 0xE0F0FF,
  },
  SUNSET: {
    sky: [0xFF7E47, 0xC55FBE, 0x7B2D8B],
    cloud: 0xFFD700,
    cloudAlt: 0xFFB6C1,
  },
  NIGHT: {
    sky: [0x1A1A3E, 0x16163A, 0x0D0D2B],
    cloud: 0xC0C0C0,
    cloudAlt: 0x8888CC,
  },
  SPACE: {
    sky: [0x0A0A1A, 0x050510, 0x000005],
    cloud: 0x00FFFF,
    cloudAlt: 0xFF00FF,
  },
};

/** 특수 구름 타입 */
export enum CloudType {
  NORMAL = 'normal',
  RAINBOW = 'rainbow',
  LIGHTNING = 'lightning',
  STAR = 'star',
  WIND = 'wind',
}

/** 특수 구름 출현 확률 (합계 = 1.0) */
export const CLOUD_WEIGHTS: Record<CloudType, number> = {
  [CloudType.NORMAL]: 0.70,
  [CloudType.RAINBOW]: 0.10,
  [CloudType.LIGHTNING]: 0.10,
  [CloudType.STAR]: 0.05,
  [CloudType.WIND]: 0.05,
};

/** 특수 구름 색상 */
export const CLOUD_COLORS: Record<CloudType, number> = {
  [CloudType.NORMAL]: 0xFFFFFF,
  [CloudType.RAINBOW]: 0xFF69B4,
  [CloudType.LIGHTNING]: 0xFFFF00,
  [CloudType.STAR]: 0xFFD700,
  [CloudType.WIND]: 0x90EE90,
};
